export const removeTrackerPopup = {
  title: 'Delete this item?',
  content:
    'Are you sure you want to delete this? Once it is deleted, it cannot be restored.<br /><checkbox>I understand deleted items cannot be restored, and I am sure I want to delete it!</checkbox>',
  ok: 'OK',
  cancel: 'Cancel',
};

export default removeTrackerPopup;
